import type {
  ChangePasswordInput,
  MySummaryResponse,
  NotificationListResponse,
  NotificationPreferenceDto,
  NotificationPreferencesInput,
  SessionDto,
  WorkScheduleDto,
} from '@i9portal/shared';
import { api } from '../client';

export const meApi = {
  summary: () => api.get<MySummaryResponse>('/me/summary'),
  workSchedules: () => api.get<WorkScheduleDto[]>('/me/work-schedules'),
  changePassword: (input: ChangePasswordInput) => api.post<void>('/me/password', input),
  sessions: () => api.get<SessionDto[]>('/me/sessions'),
  revokeSession: (id: string) => api.delete(`/me/sessions/${id}`),
  notifications: (query: { page?: number; pageSize?: number; unread?: boolean }) =>
    api.get<NotificationListResponse>('/me/notifications', {
      page: query.page,
      pageSize: query.pageSize,
      unread: query.unread ? 'true' : undefined,
    }),
  markNotificationRead: (id: string) => api.post<void>(`/me/notifications/${id}/read`),
  markAllNotificationsRead: () => api.post<void>('/me/notifications/read-all'),
  notificationPreferences: () =>
    api.get<NotificationPreferenceDto[]>('/me/notification-preferences'),
  updateNotificationPreferences: (input: NotificationPreferencesInput) =>
    api.put<NotificationPreferenceDto[]>('/me/notification-preferences', input),
};
